import { AuthPlatformEnum } from './auth-platform.enum';
import { AuthResponseModel } from './auth-response.model';
import { Verification } from './verification/verification.model';

export type LoginResponseModel = AuthResponseModel;

export class LoginBaseModel {
  token: string;
  // service version
  version = 3;

  // optional: group code
  groupInviteMode: 0 | 1 = 0;
  groupInviteKey: string;
  groupCodeMode: 0 | 1 = 0;
  groupCode: string;

  // optional: 3rd party group code
  groupOvidMode: 0 | 1;
  groupOvidOsptok: string;

  // re-captcha validation payload
  site_verify_response: Verification;

  // optional platform params, i.e., Zendesk, Smiletrain
  platform?: AuthPlatformEnum;
  returnTo?: string;
  brandId?: string;
  localeId?: string;
  timestamp?: string;

  constructor() {}
}
